import { type FC } from 'react'
import styled from 'styled-components'
import { colors } from 'theme'

interface Props extends React.PropsWithChildren {
  title: string
}

export const ChartTitle: FC<Props> = ({ title, children }) => (
  <Wrapper>
    <h3>{title}</h3>
    {children}
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 5rem;

  h3 {
    margin: 0 2rem 0 0;
    white-space: nowrap;
    font-family: Montserrat;
    color: ${colors.deepBlue};

  }

  @media (width <= 680px) {
    flex-direction: column;
  }
`
